import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-caption font-weight-bold" }
const _hoisted_2 = { key: 0 }

import { computed, ref } from 'vue';
import {
  startOfMonth, endOfMonth, startOfWeek, endOfWeek,
  addDays, format, parseISO, isValid, getMonth
} from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarMonth',
  props: {
    baseDate: {},
    events: {},
    title: {},
    moduleName: {},
    onCreate: { type: Function },
    onView: { type: Function },
    calendarConfig: {}
  },
  setup(__props: any) {

const props = __props;

const weekDays = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

const currentDate = computed(() => new Date(props.baseDate));
const currentMonth = computed(() => currentDate.value.getMonth());

const isToday = (dateStr: string) => format(new Date(), 'yyyy-MM-dd') === dateStr;
const formatTime = (datetime: string) => format(new Date(datetime), 'HH:mm');

function normalizeDate(input: string): string {
  const date = parseISO(input);
  return isValid(date) ? format(date, 'yyyy-MM-dd') : '';
}

const calendarDays = computed(() => {
  const start = startOfWeek(startOfMonth(currentDate.value), { weekStartsOn: 1 });
  const end = endOfWeek(endOfMonth(currentDate.value), { weekStartsOn: 1 });
  const days = [];

  for (let date = start; date <= end; date = addDays(date, 1)) {
    const dateObj = new Date(date);
    days.push({
      date: format(dateObj, 'yyyy-MM-dd'),
      day: format(dateObj, 'd'),
      isOutsideMonth: getMonth(dateObj) !== currentMonth.value
    });
  }

  return days;
});

const weeks = computed(() => {
  const days = calendarDays.value;
  const chunks = [];
  for (let i = 0; i < days.length; i += 7) {
    chunks.push(days.slice(i, i + 7));
  }
  return chunks;
});

const selectedRange = ref<{ start: string | null; end: string | null }>({ start: null, end: null });
let clickTimeout: ReturnType<typeof setTimeout> | null = null;

function startRangeSelection(day: { date: string }) {
  selectedRange.value.start = day.date;
  selectedRange.value.end = null;
}

function endRangeSelection(day: { date: string }) {
  if (!selectedRange.value.start) return;
  selectedRange.value.end = day.date;

  if (selectedRange.value.start > selectedRange.value.end) {
    [selectedRange.value.start, selectedRange.value.end] = [selectedRange.value.end, selectedRange.value.start];
  }

  props.onCreate?.({ date: [selectedRange.value.start, selectedRange.value.end] });

  selectedRange.value.start = null;
  selectedRange.value.end = null;
}

function handleSingleClick(day: { date: string }) {
  if (clickTimeout) clearTimeout(clickTimeout);
  clickTimeout = setTimeout(() => {
    props.onCreate?.({ date: day.date });
  }, 200);
}

const getEventsForDate = (dateStr: string) => {
  const field = props.calendarConfig?.dateField || 'date';
  return props.events.filter(e => normalizeDate(e.original?.[field]) === dateStr)
    .sort((a, b) => new Date(a.original?.[field]).getTime() - new Date(b.original?.[field]).getTime());
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-4 pt-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "text-center ma-0" }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDays, (day) => {
                return _createVNode(_component_v_col, {
                  key: day,
                  cols: 12 / 7,
                  class: "text-caption text-grey-darken-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(day), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weeks.value, (week, wIdx) => {
              return (_openBlock(), _createBlock(_component_v_row, {
                key: wIdx,
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, (day) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: day.date,
                      cols: 12 / 7,
                      class: _normalizeClass(["pa-1 border", {
                'bg-grey-darken-4': isToday(day.date),
                'outside-month': day.isOutsideMonth
              }]),
                      style: {"min-height":"100px"},
                      onMousedown: ($event: any) => (startRangeSelection(day)),
                      onMouseup: ($event: any) => (endRangeSelection(day)),
                      onClick: ($event: any) => (handleSingleClick(day))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(day.day), 1),
                        (props.events.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getEventsForDate(day.date), (event) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                  key: event.id,
                                  color: event.color || 'white',
                                  size: "x-small",
                                  class: "ma-1",
                                  onClick: _withModifiers(() => props.onView?.(event), ["stop"]),
                                  onMousedown: _withModifiers(() => props.onView?.(event), ["stop"]),
                                  onMouseup: _withModifiers(() => props.onView?.(event), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(formatTime(event.date)) + " - " + _toDisplayString(event.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color", "onClick", "onMousedown", "onMouseup"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["class", "onMousedown", "onMouseup", "onClick"]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})